import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export function CalendarTab({ currentMonth, setCurrentMonth, inquiries, onSelectEvent }) {
  const year = currentMonth.getFullYear();
  const month = currentMonth.getMonth();
  const firstDay = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const today = new Date();

  const bookedEvents = inquiries
    .filter(inq => inq.status === 'booked' && inq.event_date)
    .map(inq => ({
      ...inq,
      date: new Date(inq.event_date),
    }));

  const days = [];

  for (let i = 0; i < firstDay; i++) {
    days.push(<div key={`empty-${i}`} className="p-2 min-h-[80px]"></div>);
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = new Date(year, month, day);
    const isToday = date.toDateString() === today.toDateString();

    const dayEvents = bookedEvents.filter(event => {
      const eventDate = new Date(event.event_date);
      return eventDate.getFullYear() === year &&
             eventDate.getMonth() === month &&
             eventDate.getDate() === day;
    });

    days.push(
      <div
        key={day}
        className={`p-2 min-h-[80px] border border-gray-700 rounded-lg ${
          isToday ? 'bg-teal-900/30 border-teal-500' : 'bg-gray-900/30'
        }`}
      >
        <span className={`text-sm ${isToday ? 'text-teal-400 font-bold' : 'text-gray-400'}`}>
          {day}
        </span>
        {dayEvents.map(event => (
          <div
            key={event.id}
            onClick={() => onSelectEvent(event)}
            className="mt-1 p-1 bg-gold-500/20 border border-gold-500/50 rounded text-xs text-gold-400 truncate cursor-pointer hover:bg-gold-500/30 transition-colors"
            title={`${event.name} - ${event.event_type}`}
          >
            {event.name}
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-white">
          {currentMonth.toLocaleString('default', { month: 'long', year: 'numeric' })}
        </h2>
        <div className="flex gap-2">
          <button
            onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1))}
            className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            onClick={() => setCurrentMonth(new Date())}
            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm transition-colors"
          >
            Today
          </button>
          <button
            onClick={() => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1))}
            className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg transition-colors"
          >
            <ChevronRight size={20} />
          </button>
        </div>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
          <div key={day} className="p-2 text-center text-gray-400 text-sm font-medium">
            {day}
          </div>
        ))}
        {days}
      </div>

      <div className="mt-4 flex gap-4 text-sm text-gray-400">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-gold-500/20 border border-gold-500/50 rounded"></div>
          <span>Booked Event</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 bg-teal-900/30 border border-teal-500 rounded"></div>
          <span>Today</span>
        </div>
      </div>
    </div>
  );
}
